
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/leftBar/leftBarMenu/leftBarMenu.scss.css.virtualfile';
        module.exports = {"wrapper":"_wrapper_m5ees_7","list":"_list_m5ees_18","item":"_item_m5ees_25","primary":"_primary_m5ees_32"};